<template>
  <div class="message-audio">
    <chat-message-status
      v-if="isSending || !blob"
      :percentage="percentage"
      :isFinished="isFinished"
      :isFailed="isFailed"
      :statusDesc="statusDesc" />

    <app-audio-player v-else :blob="blob" />
  </div>
</template>

<script>
import messageMxin from './ChatMessageMixin';
import ChatMessageStatus from './ChatMessageStatus';
import SingleElementIntersectionObserver from '@/lib/single-element-intersection-observer';

export default {
  mixins: [messageMxin],

  components: {
    'chat-message-status': ChatMessageStatus
  },

  data() {
    return {
      blob: null
    };
  },

  props: {
    chatMessageDto: {
      type: Object,
      required: true
    }
  },

  watch: {
    async isAttachmentReady(v) {
      if (v) {
        this.blob = await this.chatMessageDto.GetAttachmentAsync();
      }
    }
  },

  mounted() {
    this._intersectionObserver = new SingleElementIntersectionObserver(async entry => {
      await this.retriveAttachment(this.chatMessageDto);
    });
    this._intersectionObserver.observe(this.$el);
  },

  beforeDestroy() {
    this._intersectionObserver.disconnect();
  }
};
</script>

<style lang="stylus" scoped>
.status {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0.5rem;
  flex-direction: column;
}
</style>

